import React from 'react';
import { FacebookIcon, InstagramIcon, LinkedinIcon, YoutubeIcon, PhoneIcon, MailIcon, MapPinIcon, ClockIcon } from 'lucide-react';
import { useModal } from '../App';
const serviceLinks = ['Roof Replacement', 'Roof Repair', 'Roof Inspection', 'Storm Damage', 'Commercial Roofing', 'Roof Maintenance'];
const companyLinks = ['About Us', 'Our Process', 'Project Gallery', 'Financing Options', 'Careers', 'Blog'];
const bottomLinks = ['Privacy Policy', 'Terms of Service', 'Sitemap'];
const socialIcons = [{
  icon: FacebookIcon,
  label: 'Facebook'
}, {
  icon: InstagramIcon,
  label: 'Instagram'
}, {
  icon: LinkedinIcon,
  label: 'LinkedIn'
}, {
  icon: YoutubeIcon,
  label: 'YouTube'
}];
export function Footer() {
  const {
    openModal
  } = useModal();
  const linkStyle = {
    color: '#64748B',
    fontSize: '14px',
    paddingTop: '5px',
    paddingBottom: '5px',
    textDecoration: 'none',
    cursor: 'pointer',
    display: 'block',
    background: 'none',
    border: 'none',
    textAlign: 'left' as const
  };
  return <footer style={{
    background: '#0F172A',
    borderTop: '2px solid #F59E0B',
    overflow: 'hidden'
  }} data-id="element-101">
      <div className="max-w-7xl mx-auto px-6 lg:px-8 pt-16 pb-8" data-id="element-102">
        <div className="flex flex-col lg:flex-row gap-12 lg:gap-0" data-id="element-103">

          {/* LEFT — Brand */}
          <div className="lg:w-[35%] lg:pr-12 flex flex-col gap-6" data-id="element-104">
            <button onClick={openModal} style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            textAlign: 'left',
            padding: 0
          }} data-id="element-105">
              <div className="flex items-center gap-3" data-id="element-106">
                <div className="w-10 h-10 rounded-lg flex items-center justify-center flex-shrink-0" style={{
                background: '#F59E0B'
              }} data-id="element-107">
                  <span className="text-white font-black text-lg leading-none" data-id="element-108">P</span>
                </div>
                <div data-id="element-109">
                  <p className="text-white font-bold text-xl leading-none" data-id="element-110">ProRoof</p>
                  <p style={{
                  color: '#94A3B8',
                  fontSize: '12px'
                }} className="mt-0.5" data-id="element-111">Roofing, Done Right.</p>
                </div>
              </div>
            </button>

            <p style={{
            color: '#64748B',
            fontSize: '14px',
            lineHeight: '1.6'
          }} data-id="element-112">
              Premium roofing contractor serving Central Texas with integrity, quality craftsmanship, and transparent pricing.
            </p>

            {/* Social icons */}
            <div className="flex items-center gap-3" data-id="element-113">
              {socialIcons.map(({
              icon: Icon,
              label
            }) => <button key={label} aria-label={label} onClick={openModal} className="w-8 h-8 rounded-lg flex items-center justify-center transition-colors" style={{
              border: '1px solid #1E293B',
              background: 'transparent',
              cursor: 'pointer'
            }} onMouseEnter={e => {
              (e.currentTarget as HTMLButtonElement).style.background = '#1E293B';
            }} onMouseLeave={e => {
              (e.currentTarget as HTMLButtonElement).style.background = 'transparent';
            }} data-id="element-114">
                  <Icon size={14} color="#94A3B8" data-id="element-115" />
                </button>)}
            </div>

            <p style={{
            color: '#334155',
            fontSize: '11px'
          }} data-id="element-116">Licensed &amp; Insured | TX Lic. #ROF-2024-001</p>
          </div>

          {/* RIGHT — Three columns */}
          <div className="lg:w-[65%] flex flex-col sm:flex-row gap-10 sm:gap-0" data-id="element-117">

            {/* Services */}
            <div className="flex-1 sm:px-8 sm:border-r" style={{
            borderColor: '#1E293B'
          }} data-id="element-118">
              <p className="mb-5 tracking-widest" style={{
              color: '#F59E0B',
              fontSize: '11px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.1em'
            }} data-id="element-119">
                Services
              </p>
              <ul className="flex flex-col gap-1" data-id="element-120">
                {serviceLinks.map(link => <li key={link} data-id="element-121">
                    <button onClick={openModal} style={linkStyle} onMouseEnter={e => {
                  (e.currentTarget as HTMLButtonElement).style.color = '#F1F5F9';
                }} onMouseLeave={e => {
                  (e.currentTarget as HTMLButtonElement).style.color = '#64748B';
                }} data-id="element-122">
                      {link}
                    </button>
                  </li>)}
              </ul>
            </div>

            {/* Company */}
            <div className="flex-1 sm:px-8 sm:border-r" style={{
            borderColor: '#1E293B'
          }} data-id="element-123">
              <p className="mb-5" style={{
              color: '#F59E0B',
              fontSize: '11px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.1em'
            }} data-id="element-124">
                Company
              </p>
              <ul className="flex flex-col gap-1" data-id="element-125">
                {companyLinks.map(link => <li key={link} data-id="element-126">
                    <button onClick={openModal} style={linkStyle} onMouseEnter={e => {
                  (e.currentTarget as HTMLButtonElement).style.color = '#F1F5F9';
                }} onMouseLeave={e => {
                  (e.currentTarget as HTMLButtonElement).style.color = '#64748B';
                }} data-id="element-127">
                      {link}
                    </button>
                  </li>)}
              </ul>
            </div>

            {/* Contact */}
            <div className="flex-1 sm:pl-8" data-id="element-128">
              <p className="mb-5" style={{
              color: '#F59E0B',
              fontSize: '11px',
              fontWeight: 600,
              textTransform: 'uppercase',
              letterSpacing: '0.1em'
            }} data-id="element-129">
                Contact Us
              </p>
              <div className="flex flex-col gap-4" data-id="element-130">
                <button onClick={openModal} style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
                textAlign: 'left',
                padding: 0
              }} data-id="element-131">
                  <div className="flex items-start gap-2.5" data-id="element-132">
                    <PhoneIcon size={14} color="#F59E0B" className="mt-0.5 flex-shrink-0" data-id="element-133" />
                    <div data-id="element-134">
                      <p className="text-white font-semibold" style={{
                      fontSize: '14px'
                    }} data-id="element-135">(555) 000-0000</p>
                      <p style={{
                      color: '#475569',
                      fontSize: '11px'
                    }} data-id="element-136">24/7 Emergency Service</p>
                    </div>
                  </div>
                </button>
                <div className="flex items-center gap-2.5" data-id="element-137">
                  <MailIcon size={14} color="#F59E0B" className="flex-shrink-0" data-id="element-138" />
                  <button onClick={openModal} style={{
                  color: '#64748B',
                  fontSize: '14px',
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  padding: 0
                }} onMouseEnter={e => {
                  (e.currentTarget as HTMLButtonElement).style.color = '#F1F5F9';
                }} onMouseLeave={e => {
                  (e.currentTarget as HTMLButtonElement).style.color = '#64748B';
                }} data-id="element-139">
                    hello@proroof.com
                  </button>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-140">
                  <MapPinIcon size={14} color="#F59E0B" className="mt-0.5 flex-shrink-0" data-id="element-141" />
                  <p style={{
                  color: '#64748B',
                  fontSize: '14px',
                  lineHeight: '1.5'
                }} data-id="element-142">
                    123 Roofing Way, Suite 100<br data-id="element-143" />Austin, TX 78701
                  </p>
                </div>
                <div className="flex items-start gap-2.5" data-id="element-144">
                  <ClockIcon size={14} color="#F59E0B" className="mt-0.5 flex-shrink-0" data-id="element-145" />
                  <p style={{
                  color: '#475569',
                  fontSize: '12px',
                  lineHeight: '1.5'
                }} data-id="element-146">
                    Mon–Sat: 7am–7pm<br data-id="element-147" />Sun: Emergency Only
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-4 flex flex-col sm:flex-row justify-between items-center gap-3" style={{
        borderTop: '1px solid #1E293B'
      }} data-id="element-148">
          <p style={{
          color: '#334155',
          fontSize: '12px'
        }} data-id="element-149">© 2026 ProRoof Contractors. All rights reserved.</p>
          <div className="flex items-center gap-4" data-id="element-150">
            {bottomLinks.map((item, i) => <React.Fragment key={item} data-id="element-151">
                {i > 0 && <span style={{
              color: '#1E293B'
            }} data-id="element-152">·</span>}
                <button onClick={openModal} style={{
              color: '#334155',
              fontSize: '12px',
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: 0
            }} onMouseEnter={e => {
              (e.currentTarget as HTMLButtonElement).style.color = '#64748B';
            }} onMouseLeave={e => {
              (e.currentTarget as HTMLButtonElement).style.color = '#334155';
            }} data-id="element-153">
                  {item}
                </button>
              </React.Fragment>)}
          </div>
        </div>
      </div>

      {/* Ghost wordmark */}
      <div style={{
      overflow: 'hidden',
      lineHeight: 0.8,
      marginTop: '8px'
    }} data-id="element-154">
        <p style={{
        fontSize: 'clamp(120px, 15vw, 220px)',
        fontWeight: 900,
        color: 'rgba(245, 158, 11, 0.07)',
        letterSpacing: '-0.03em',
        textAlign: 'center',
        lineHeight: 0.85,
        width: '100%',
        userSelect: 'none',
        pointerEvents: 'none',
        margin: 0,
        padding: 0
      }} data-id="element-155">
          PROROOF
        </p>
      </div>
    </footer>;
}